(() => {
  /* Card ATC is handled in lume-cart.js (loads on every page).
     This file is PDP-only: qty, purchase type, gallery, form submit. */

  const page = document.querySelector('.pp-page');
  if (!page) return;

  let qty = 1;
  let type = 'one';
  const unitBase = Number(page.dataset.price || 0);
  const qtyEl = document.getElementById('ppQty');
  const qtyInput = document.getElementById('ppQtyInput');
  const totalEl = document.getElementById('ppTotal');
  const priceEl = document.getElementById('ppPrice');
  const form = document.getElementById('ppForm');
  const photos = Array.from(page.querySelectorAll('[data-pp-photo]')).map((el) => ({
    src: el.dataset.ppPhoto,
    lifestyle: el.dataset.ppLifestyle === '1',
    el,
  }));
  let photoIdx = 0;

  const unit = () => (type === 'sub' ? Math.round(unitBase * 0.85) : unitBase);

  const refresh = () => {
    if (qtyEl) qtyEl.textContent = String(qty);
    if (qtyInput) qtyInput.value = String(qty);
    const money = window.LUME ? LUME.formatMoney(unit() * qty) : String(unit() * qty);
    if (totalEl) totalEl.textContent = money;
    if (priceEl) priceEl.textContent = window.LUME ? LUME.formatMoney(unit()) : String(unit());
    const sb = document.getElementById('ppSbPrice');
    if (sb) sb.textContent = money;
  };

  const showPhoto = (idx) => {
    if (!photos.length) return;
    photoIdx = (idx + photos.length) % photos.length;
    const p = photos[photoIdx];
    const img = document.getElementById('ppPhoto');
    const stage = document.getElementById('ppStage');
    if (img) img.src = p.src;
    stage?.classList.toggle('is-lifestyle', p.lifestyle);
    photos.forEach((x, i) => x.el.classList.toggle('active', i === photoIdx));
  };

  page.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-pp-qty]');
    if (q) {
      qty = Math.max(1, qty + Number(q.dataset.ppQty));
      refresh();
      return;
    }
    const tab = e.target.closest('[data-pp-type]');
    if (tab) {
      type = tab.dataset.ppType;
      page.querySelectorAll('[data-pp-type]').forEach((t) => t.classList.toggle('active', t === tab));
      refresh();
      return;
    }
    const thumb = e.target.closest('[data-pp-photo]');
    if (thumb) {
      const idx = photos.findIndex((p) => p.el === thumb);
      showPhoto(idx);
      return;
    }
    const step = e.target.closest('[data-pp-step]');
    if (step) {
      showPhoto(photoIdx + Number(step.dataset.ppStep));
      return;
    }
    if (e.target.closest('#ppStickyAdd') && form) {
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  });

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const id = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
      if (!id || !window.LUME || !LUME.addToCart) return;
      await LUME.addToCart(id, qty);
    });
  }

  const cv = document.getElementById('ppCanvas');
  if (cv && document.documentElement.dataset.lumeAnim !== 'off' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const ctx = cv.getContext('2d');
    const color = page.dataset.color || '#274634';
    const nm = Number(page.dataset.nm) || 644;
    let W = 0, H = 0, t = 0, raf = 0, visible = false;
    const size = () => {
      W = cv.width = cv.offsetWidth * devicePixelRatio;
      H = cv.height = Math.max(120, cv.offsetHeight) * devicePixelRatio;
    };
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      ctx.beginPath();
      const amp = H * 0.22;
      const cycles = 1800 / nm;
      for (let x = 0; x <= W; x += 3) {
        const y = H * 0.5 + Math.sin((x / W) * cycles * Math.PI * 2 - t) * amp;
        if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.strokeStyle = color;
      ctx.lineWidth = 2 * devicePixelRatio;
      ctx.stroke();
      t += 0.04;
      if (visible) raf = requestAnimationFrame(draw);
    };
    size();
    window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        visible = e.isIntersecting;
        if (visible) {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(draw);
        }
      }, { threshold: 0.05 }).observe(cv);
    } else {
      visible = true;
      raf = requestAnimationFrame(draw);
    }
  }

  refresh();
})();
